import {FC} from "react";
import {useStyles} from './SenseBanner.styles';
import {useTranslation} from 'react-i18next';
import {useStores} from "hooks";
import {detectMob} from 'utils';
import {TEXT} from 'texts';

import src from './images/senseLogo.svg';

const SenseBanner: FC = () => {
    const {dataStore} = useStores();
    const {t} = useTranslation();
    const styles = useStyles();

    const deepLink = dataStore.appData?.deepLinkApp;
    const isMobile = detectMob();

    return (
        isMobile ?
            <div className={styles.bannerWrap}>
                <img src={src} alt=""/>
                <div className={styles.textWrap}>
                    <p className={styles.bannerTitle}>{t(TEXT.senseBannerTitle)}</p>
                    <p className={styles.bannerSubTitle}>{t(TEXT.senseBannerSubTitle)}</p>
                </div>
                <a className={styles.bannerLink} href={deepLink}>{t(TEXT.senseBannerLink)}</a>
            </div>
            : null
    )
}

export default SenseBanner